import ReportsAPI from 'media-base-ui/utils/reportsAPI';
import GameTypeAPI from 'media-base-ui/utils/gameTypeAPI';

import actionCreators from './actionCreators';

const hydrateTeamFilter = actionCreators.hydrateTeamFilter;
const changeGameTypeValue = actionCreators.changeGameTypeValue;
const changeReportSelection = actionCreators.changeReportSelection;
const changeTeamSelection = actionCreators.changeTeamSelection;
const changeAllSelection = actionCreators.changeAllSelection;

const fetchReportData = (reports, season, gameType) => async dispatch => {
    dispatch(actionCreators.requestReportData());

    try {
        const response = await ReportsAPI.fetchReportData({
            reports,
            season,
            gameType
        });

        dispatch(actionCreators.reportDataResponse(true, response.url));
    } catch (error) {
        dispatch(actionCreators.reportDataResponse(false, ''))
    }
};

const fetchGameTypeData = () => async dispatch => {
    dispatch(actionCreators.requestGameTypeData());

    try {
        const data = await GameTypeAPI.fetchRegularPlayoffGameTypes();

        GameTypeAPI.generateGameTypeSelectOptions(data.data);
        dispatch(actionCreators.gameTypeResponse(true, data, null));
    } catch (error) {
        dispatch(actionCreators.seasonsResponse(false, [], error))
    }
};

export default {
    changeGameTypeValue,
    changeReportSelection,
    changeTeamSelection,
    changeAllSelection,
    fetchReportData,
    fetchGameTypeData,
    hydrateTeamFilter
}
